import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { OrderForListing } from '../../models/OrderForListing';

interface IOrderAlertPopoverProps {
  orderForListing: OrderForListing;
}

export const OrderAlertPopover: React.FC<IOrderAlertPopoverProps> = ({
  orderForListing
}) => {

  return orderForListing._alerts && orderForListing._alerts.length > 0 ?
    <span style={{ marginLeft: '5px' }}>
      <OverlayTrigger
        placement="right"
        delay={{ show: 250, hide: 400 }}
        overlay={<Tooltip style={{ display: 'flex', flexDirection: 'column' }}>
          {orderForListing._alerts.map((alert, nindex) => {
            return (
              <div key={`order-alert-${orderForListing.order.id}-${nindex}`} style={{ textAlign: 'left' }}>{alert.value}</div>
            );
          })}
        </Tooltip>}
      >
        <span><FontAwesomeIcon icon={faExclamationTriangle} color='red' size='sm' /></span>
      </OverlayTrigger>
    </span>
  : null;

}